interface TypingIndicatorProps {
  tool?: string | null;
}

const TOOL_LABEL: Record<string, string> = {
  get_skills:       'checking skills…',
  get_experience:   'checking experience…',
  get_education:    'checking education…',
  get_projects:     'loading projects…',
  search_projects:  'searching projects…',
  get_services:     'loading services…',
  get_blogs:        'loading posts…',
  get_testimonials: 'checking reviews…',
  get_contact_info: 'fetching contact…',
  get_social_links: 'fetching links…',
  get_availability: 'checking availability…',
  create_inquiry:   'submitting inquiry…',
};

export function TypingIndicator({ tool }: TypingIndicatorProps) {
  const label = tool ? (TOOL_LABEL[tool] ?? 'looking up…') : null;

  return (
    <div className="flex items-center gap-2 px-4 py-3" aria-label="Assistant is typing" role="status">
      <div className="flex items-center gap-1">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            aria-hidden="true"
            className="w-2 h-2 rounded-full bg-neutral-400 dark:bg-neutral-600"
            style={{ animation: `pulse-dot 1.2s ease-in-out ${i * 0.16}s infinite` }}
          />
        ))}
      </div>
      {label && (
        <span className="text-xs text-(--muted) animate-pulse">{label}</span>
      )}
    </div>
  );
}

export default TypingIndicator;
